/* Format a raw rupee number as an Indian-style currency string with
   automatic Lakh / Crore suffixing. The customer site uses the same
   format so what shows in the admin list matches what visitors see. */
export function formatINR(n) {
  if (n == null || Number.isNaN(n)) return "—";
  if (n >= 1e7) {
    const cr = n / 1e7;
    return "₹" + (cr % 1 === 0 ? cr.toFixed(0) : cr.toFixed(2).replace(/\.?0+$/, "")) + " Cr";
  }
  if (n >= 1e5) {
    const lk = n / 1e5;
    return "₹" + (lk % 1 === 0 ? lk.toFixed(0) : lk.toFixed(2).replace(/\.?0+$/, "")) + " L";
  }
  return "₹" + n.toLocaleString("en-IN");
}

/* Return a "from ₹X" / "₹X – ₹Y" / "₹X" range string from a property's
   configs[] array. Used in the list card price chip. */
export function priceRangeFromConfigs(configs) {
  if (!configs?.length) return "—";
  const prices = configs.map((c) => c.price).filter((p) => p != null && !Number.isNaN(p));
  if (!prices.length) return "—";
  const min = Math.min(...prices);
  const max = Math.max(...prices);
  if (min === max) return formatINR(min);
  return `${formatINR(min)} – ${formatINR(max)}`;
}

/* Slugify — kebab-case, ASCII-folded. Used by the SEO step to auto-
   suggest a slug from the title. */
export function slugify(s) {
  return String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
}
